import { Params } from '@angular/router';
import { NavigationHelperConfig } from '~shared/services/navigation-helper.service';
import { PriceFilterRange } from '~shared/models';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';


export class PriceFilterHandler {
  private static _instance: PriceFilterHandler;
  public static get instance(): PriceFilterHandler {
    if (!PriceFilterHandler._instance) {
      PriceFilterHandler._instance = new PriceFilterHandler();
    }

    return PriceFilterHandler._instance;
  }

  protected queryParams: Params;

  protected constructor() {
  }

  updateQueryParams(params: Params): void {
    this.queryParams = params;
  }

  apply(priceRanges: PriceFilterRange): FilterHandlerParams {
    const { filter: { options = {}, price: prevPrice = {}, ...rest } = {} } = this.queryParams || {};
    const price = { price: { ...priceRanges } };
    return { params: { filter: { ...price, options, ...rest } }, config: { resetPaging: true } };
  }

  remove(): FilterHandlerParams {
    return this.apply({ from: null, to: null });
  }

  reset(): FilterHandlerParams {
    return this.apply({ from: null, to: null });
  }
}
